import { message } from "antd";
import { inventoryService } from "../services/inventory";
import { localErrorHandler } from "../utils/errorHandler";

const namespace = "inventory";

const initialState = {
  list: [],
  pagination: { total: 0 },
  filters: {},
  loading: {
    fetch: false,
    create: false,
    update: false,
  },
};

export const fetchInventory = (params) => ({
  type: `${namespace}/fetchInventory`,
  payload: params,
});

export const create = (data) => ({
  type: `${namespace}/create`,
  payload: data,
});

export const update = (id, data) => ({
  type: `${namespace}/update`,
  payload: { id, data },
});

export const resetInventory = () => ({
  type: `${namespace}/resetInventory`,
});

export default {
  namespace,
  state: initialState,
  effects: {
    *fetchInventory({ payload }, { call, put, select }) {
      yield put({ type: "startLoading", loadingType: "fetch" });
      const currentFilters = yield select((state) => state[namespace].filters);
      const shopId = yield select((state) => state.shop?.data?.id);
      const filtersToUse = payload || currentFilters;

      try {
        const response = yield call(inventoryService.getInventoryItems, {
          shopId,
          ...filtersToUse,
        });
        const items =
          response.data?.list ||
          (Array.isArray(response.data) ? response.data : []);
        const total =
          response.data?.total ||
          (Array.isArray(response.data) ? response.data.length : items.length);

        yield put({
          type: "setInventoryItems",
          payload: {
            list: items,
            pagination: { total },
            filters: filtersToUse,
          },
        });
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "fetch" });
      } finally {
        yield put({ type: "stopLoading", loadingType: "fetch" });
      }
    },

    *create({ payload }, { call, put }) {
      yield put({ type: "startLoading", loadingType: "create" });
      try {
        const response = yield call(inventoryService.create, payload);
        message.success("Inventory item created successfully");
        return response;
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "create" });
      } finally {
        yield put({ type: "stopLoading", loadingType: "create" });
      }
    },

    *update({ payload }, { call, put }) {
      const { id, data } = payload;
      yield put({ type: "startLoading", loadingType: "update" });
      try {
        const response = yield call(inventoryService.update, id, data);
        message.success("Inventory item updated successfully");
        return response;
      } catch (error) {
        localErrorHandler({ namespace, error, stopLoading: "update" });
      } finally {
        yield put({ type: "stopLoading", loadingType: "update" });
      }
    },

    *resetInventory(_, { put }) {
      yield put({ type: "resetState" });
    },
  },
  reducers: {
    setInventoryItems(state, { payload }) {
      return {
        ...state,
        list: payload.list,
        pagination: payload.pagination,
        filters: payload.filters,
      };
    },
    startLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: true } };
    },
    stopLoading(state, { loadingType }) {
      return { ...state, loading: { ...state.loading, [loadingType]: false } };
    },
    resetState() {
      return initialState;
    },
  },
};
